// Loading.js
import React from "react";
import "../App.css";

const Loading = ({ message = "Loading..." }) => {
    return (
        <div className="loading-wrapper">
            <div className="spinner-wrapper">
                <div className="spinner"></div>
            </div>
            <p className="loading-message">{message}</p>
        </div>
    );
};

export default Loading;
